import React, { useEffect, useState } from 'react'
import useAxiosInstance from '../../hooks/useAxios';
import FormRender from '../../components/FormRender';
import { FORM_SETTING_REPORT_TYPE_EDIT } from '../../helper';
import { toast } from 'react-toastify';

const EditReportType = () => {
    const [loading, setLoading] = useState(false)
    const axiosInstance = useAxiosInstance()
    const [formData, setFormData] = useState({})
    const [originalData, setOriginalData] = useState(null)
    const [uiCategory, setUiCategory] = useState([])
    const [uiOutputType, setUiOutputType] = useState('')
    const [uiTags, setUiTags] = useState([])
    const [subHeader, setSubHeader] = useState('')
    const [sampleReportIdsInput, setSampleReportIdsInput] = useState('')
    const pk = Number(window.location.href.split('/').pop())
    const [reTrigger,setReTrigger] = useState(0);

    useEffect(() => {
        setLoading(true);
        axiosInstance
            .post("/accounts/get_report_type/", {
                pk: pk,
            })
            .then((res) => {
                setLoading(false);
                const data = res.data.data || {};
                setFormData(data)
                setOriginalData(data)
                const meta = data.meta || {};
                const ui_config = meta.ui_config || {};
                setUiCategory(ui_config.category || [])
                setUiOutputType(ui_config.ui_output_type || '')
                setUiTags(ui_config.tags || [])
                setSubHeader(ui_config.sub_header || '')
                const ids = meta.sample_report_ids
                setSampleReportIdsInput(Array.isArray(ids) ? ids.join(', ') : '')
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [pk,reTrigger]);


    return (
        <div className="h-screen overflow-y-auto pr-2 mr-2">
            <p className="text-base font-semibold  my-2 px-2 py-2 bg-white rounded-lg border">
                Edit Report Type
            </p>
            <p className='text-sm py-3 font-semibold flex justify-end'>Only fields marked as * are editable</p>
            {loading ? <p className='font-medium text-sm'>Loading...</p>:
            <div className='p-3 bg-white border rounded-lg'>
                <FormRender
                    formData={formData}
                    formSettings={FORM_SETTING_REPORT_TYPE_EDIT}
                    setFormData={setFormData}
                />
                {/* UI configuration fields */}
                <div className="mt-4">
                    <div className="text-sm font-semibold mb-2">UI Category</div>
                    <select
                        multiple
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                        value={uiCategory}
                        onChange={(e) => {
                            const values = Array.from(e.target.selectedOptions).map(
                                (opt) => opt.value
                            );
                            setUiCategory(values);
                        }}
                    >
                        <option value="recommended">recommended</option>
                        <option value="library">library</option>
                        <option value="custom">custom</option>
                    </select>
                    <p className="text-xs text-gray-500 mt-1">
                        Hold Ctrl (Windows) or Cmd (Mac) to select multiple.
                    </p>
                </div>

                <div className="mt-4">
                    <div className="text-sm font-semibold mb-2">UI Output Type</div>
                    <select
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                        value={uiOutputType}
                        onChange={(e) => setUiOutputType(e.target.value)}
                    >
                        <option value={""}>Choose</option>
                        <option value="grid">grid</option>
                        <option value="research">research</option>
                    </select>
                </div>

                <div className="mt-4">
                    <div className="text-sm font-semibold mb-2">Tags</div>
                    <select
                        multiple
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                        value={uiTags}
                        onChange={(e) => {
                            const values = Array.from(e.target.selectedOptions).map(
                                (opt) => opt.value
                            );
                            setUiTags(values);
                        }}
                    >
                        <option value="Highly used">Highly used</option>
                    </select>
                    <p className="text-xs text-gray-500 mt-1">
                        Leave empty for no tags.
                    </p>
                </div>

                <div className="mt-4">
                    <div className="text-sm font-semibold mb-2">Custom Category Sub Header</div>
                    <input
                        type="text"
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                        value={subHeader}
                        onChange={(e) => setSubHeader(e.target.value)}
                        placeholder="Enter sub header"
                    />
                </div>

                <div className="mt-4">
                    <div className="text-sm font-semibold mb-2">Sample Report IDs</div>
                    <input
                        type="text"
                        className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400"
                        value={sampleReportIdsInput}
                        onChange={(e) => setSampleReportIdsInput(e.target.value)}
                        placeholder="e.g. 1, 2, 3"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        Comma-separated report IDs (integers).
                    </p>
                </div>

                <button
                    disabled={loading}
                    className="flex gap-1 items-center px-2 py-1 mt-2 border border-black bg-black disabled:bg-[#b6b6b6] disabled:text-white text-white rounded-lg"
                    onClick={() => {
                        setLoading(true)
                        const icon = formData?.icon;
                        const isValidUrl = (value) => {
                            try {
                                // eslint-disable-next-line no-new
                                new URL(value);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        };

                        if (icon && !isValidUrl(icon)) {
                            setLoading(false);
                            toast.error("Please enter a valid icon URL");
                            return;
                        }

                        const payloads = {
                            pk: pk,
                            label: formData.label,
                            description: formData.description,
                            order_preference: formData.order_preference,
                            is_sandbox: formData.is_sandbox == "true" ? true : false,
                        }
                        if (originalData && icon && icon !== originalData.icon) {
                            payloads.icon = icon;
                        }
                        payloads.ui_config = {
                            category: uiCategory,
                            ui_output_type: uiOutputType,
                            tags: uiTags,
                            sub_header: subHeader,
                        };
                        payloads.sample_report_ids = sampleReportIdsInput
                            .split(',')
                            .map((s) => parseInt(s.trim(), 10))
                            .filter((n) => !Number.isNaN(n))
                        axiosInstance
                            .post("/accounts/edit_report_type/", payloads)
                            .then((res) => {
                                setLoading(false);
                                const data = res.data.data || {};
                                setFormData(data)
                                setOriginalData(data)
                                const newMeta = data.meta || {};
                                const newUiConfig = newMeta.ui_config || {};
                                setUiCategory(newUiConfig.category || [])
                                setUiOutputType(newUiConfig.ui_output_type || '')
                                setUiTags(newUiConfig.tags || [])
                                setSubHeader(newUiConfig.sub_header || '')
                                const ids = data.meta?.sample_report_ids
                                setSampleReportIdsInput(Array.isArray(ids) ? ids.join(', ') : '')
                                setReTrigger(prev=>prev+1)
                            })
                            .catch((err) => {
                                setLoading(false);
                            });
                    }}
                    >
                    {!loading ? "Save" : "Loading...."}
                </button>
            </div>}
        </div>
    )
}

export default EditReportType